import React from 'react'
import { TypeAnimation } from 'react-type-animation';


function Descritpion() {
  return (
      <div className='description-container'>
          <h1>Innovate for digital transformation.</h1>
      <TypeAnimation
      sequence={[
        'Our team of experts are ready to help you build your next big thing.', // Types 'One'
        5000 // Waits 1s
        
      ]}
        wrapper="div"
        className='description-text'
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '2em' }}
    />
      </div>
  )
}

export default Descritpion